(() => {
  const GRID_SELECTOR = '.product-list';
  const PAGINATION_SELECTOR = '.pagination-row';

  let loading = false;
  let observer = null;
  let loadedUrls = new Set();

  function getPageNumber(url) {
    try {
      const parsed = new URL(url, window.location.origin);
      return parseInt(parsed.searchParams.get('page') || '1', 10);
    } catch (e) {
      return 1;
    }
  }

  function getNextUrl(root = document) {
    const pagination = root.querySelector(PAGINATION_SELECTOR);

    if (!pagination) return null;

    /* Best option — Shopify/Symmetry next-page link */
    const directNext = pagination.querySelector(
      'a[rel="next"], a[aria-label*="next" i], a.pagination__next'
    );

    if (directNext && directNext.href) {
      return directNext.href;
    }

    /* Fallback — find the lowest page number after our current one */
    const links = [...pagination.querySelectorAll('a[href]')];

    let currentHighest = 1;

    loadedUrls.forEach(url => {
      currentHighest = Math.max(currentHighest, getPageNumber(url));
    });

    currentHighest = Math.max(
      currentHighest,
      getPageNumber(window.location.href)
    );

    let bestUrl = null;
    let bestPage = Infinity;

    links.forEach(link => {
      try {
        const url = new URL(link.href, window.location.origin);
        const page = parseInt(url.searchParams.get('page') || '0', 10);

        if (
          page > currentHighest &&
          page < bestPage &&
          !loadedUrls.has(url.href)
        ) {
          bestPage = page;
          bestUrl = url.href;
        }
      } catch (e) {}
    });

    return bestUrl;
  }

  function createLoader() {
    let loader = document.querySelector('.dd-infinite-loader');

    if (!loader) {
      loader = document.createElement('div');
      loader.className = 'dd-infinite-loader';

      const pagination = document.querySelector(PAGINATION_SELECTOR);
      const grid = document.querySelector(GRID_SELECTOR);

      if (pagination) {
        pagination.insertAdjacentElement('afterend', loader);
      } else if (grid) {
        grid.insertAdjacentElement('afterend', loader);
      }
    }

    return loader;
  }

  async function loadMore() {
    if (loading) return;

    const grid = document.querySelector(GRID_SELECTOR);
    const currentPagination = document.querySelector(PAGINATION_SELECTOR);
    const loader = createLoader();

    if (!grid) return;

    const nextUrl = getNextUrl();

    if (!nextUrl || loadedUrls.has(nextUrl)) {
      if (observer) observer.disconnect();
      loader.textContent = '';
      return;
    }

    loading = true;
    loader.textContent = 'Loading more';

    try {
      const response = await fetch(nextUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Could not load next collection page');
      }

      const html = await response.text();

      const parsed = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const newGrid = parsed.querySelector(GRID_SELECTOR);
      const newPagination = parsed.querySelector(PAGINATION_SELECTOR);

      if (!newGrid) {
        throw new Error('Product grid was not found');
      }

      const newProducts = [...newGrid.children];

      newProducts.forEach(product => {
        grid.appendChild(document.importNode(product, true));
      });

      /* Replace hidden pagination with the next page's pagination */
      if (currentPagination) {
        if (newPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
        } else {
          currentPagination.innerHTML = '';
        }
      }

      loadedUrls.add(nextUrl);

      document.dispatchEvent(
        new CustomEvent('dd:collection:products-loaded', {
          detail: {
            url: nextUrl,
            count: newProducts.length
          }
        })
      );

      if (!getNextUrl()) {
        if (observer) observer.disconnect();
        loader.textContent = '';
      } else {
        loader.textContent = '';
      }

    } catch (error) {
      console.error('Dainty Delilah infinite scroll:', error);

      /* Don't ruin shopping if something ever fails */
      loader.textContent = '';
    }

    loading = false;
  }

  function initialiseInfiniteScroll() {
    const grid = document.querySelector(GRID_SELECTOR);

    if (!grid) return;

    const loader = createLoader();

    if (observer) {
      observer.disconnect();
    }

    observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            loadMore();
          }
        });
      },
      {
        root: null,

        /* Start loading BEFORE customer reaches the bottom */
        rootMargin: '900px 0px',

        threshold: 0
      }
    );

    observer.observe(loader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseInfiniteScroll
    );
  } else {
    initialiseInfiniteScroll();
  }

})();